import { SHIFTS } from 'models/Permission'
import ROUTES from 'routing/adminRoutes'
import { FEATURE_TOGGLE_POST_SHIFT_REDESIGN } from 'config/featureToggles'
import {
  AsyncBulkEditShifts,
  AsyncShiftFullDuplicate,
  AsyncShifts,
  AsyncShiftFullCopyV2,
  AsyncShiftFullPostV2,
  AsyncShiftFullEdit,
} from 'ui/pages'
import { EditShiftAdmin } from '@src/features/shift-post-v2/pages/edit-shift-admin'
import AdminRouteLayout from '../../../Admin/AdminRouteLayout'
import AdminRoute from '../../AdminRoute'

const shiftRoutes = [
  <AdminRoute
    exact
    path={ROUTES.EDIT_SHIFT_OLD}
    layout={AdminRouteLayout}
    component={AsyncShiftFullEdit}
    requiredPermissions={[SHIFTS.UPDATE_SHIFTS]}
    key={ROUTES.EDIT_SHIFT_OLD}
  />,
  <AdminRoute
    exact
    path={ROUTES.SHIFTS}
    layout={AdminRouteLayout}
    component={AsyncShifts}
    requiredPermissions={[SHIFTS.READ_SHIFTS]}
    key={ROUTES.SHIFTS}
  />,
  <AdminRoute
    exact
    path={ROUTES.DUPLICATE_SHIFT}
    layout={AdminRouteLayout}
    component={AsyncShiftFullDuplicate}
    requiredPermissions={[SHIFTS.CREATE_SHIFTS]}
    key={ROUTES.DUPLICATE_SHIFT}
  />,
  <AdminRoute
    exact
    path={ROUTES.EDIT_SHIFT}
    layout={AdminRouteLayout}
    component={EditShiftAdmin}
    requiredPermissions={[SHIFTS.UPDATE_SHIFTS]}
    key={ROUTES.EDIT_SHIFT}
  />,
  <AdminRoute
    exact
    path={ROUTES.BULK_EDIT_SHIFTS}
    layout={AdminRouteLayout}
    component={AsyncBulkEditShifts}
    requiredPermissions={[SHIFTS.UPDATE_SHIFTS]}
    key={ROUTES.BULK_EDIT_SHIFTS}
  />,
  FEATURE_TOGGLE_POST_SHIFT_REDESIGN && (
    <AdminRoute
      exact
      path={ROUTES.POST_SHIFT}
      layout={AdminRouteLayout}
      component={AsyncShiftFullPostV2}
      requiredPermissions={[SHIFTS.CREATE_SHIFTS]}
      key={ROUTES.POST_SHIFT}
    />
  ),
  FEATURE_TOGGLE_POST_SHIFT_REDESIGN && (
    <AdminRoute
      exact
      path={ROUTES.COPY_SHIFT}
      layout={AdminRouteLayout}
      component={AsyncShiftFullCopyV2}
      requiredPermissions={[SHIFTS.CREATE_SHIFTS]}
      key={ROUTES.COPY_SHIFT}
    />
  ),
].filter((item) => item !== false)

export default shiftRoutes
